import React from 'react';
import { StarIcon, MapPinIcon } from 'lucide-react';
import { Card } from '../ui/Card';
interface Testimonial {
  name: string;
  age: string;
  context: string;
  location: string;
  quote: string;
  image: string;
}
const testimonials: Testimonial[] = [{
  name: 'Carmen V.',
  age: '57 años',
  context: '3 años post-menopausia',
  location: 'Ciudad de México',
  quote: 'Llevo 3 años probando de todo. Dietas, batidos, hasta una aplicación de ayuno que me puso de pésimo humor. Nada funcionaba y siempre terminaba recuperando todo en un mes. Lo que me convenció de este método fue que por primera vez alguien me explicó POR QUÉ no me funcionaba lo de antes. El cortisol. Nunca nadie me había hablado de eso. En la primera semana no bajé mucho en la báscula pero mi cara se deshinchó y dormí completo dos noches seguidas. Para mí eso ya valía todo.',
  image: 'https://cdn.magicpatterns.com/uploads/9Md3EQu7RWKi2LzNQxzxdE/resena_1_silver.png'
}, {
  name: 'Patricia M.',
  age: '52 años',
  context: 'enfermera, turno nocturno',
  location: 'Bogotá, Colombia',
  quote: 'Soy enfermera y trabajo turnos nocturnos. Mi metabolismo estaba destruido. Engordé 8 kilos en un año sin cambiar casi nada de lo que comía. Compré esto con desconfianza honestamente. Pero la rutina nocturna de 10 minutos me cambió todo. No es magia, es que por fin estoy durmiendo mejor. Y cuando duermes bien, todo lo demás empieza a acomodarse. Al día 12 mi supervisora me preguntó si me había hecho algo en la cara porque me veía diferente.',
  image: 'https://cdn.magicpatterns.com/uploads/cKHitsRsNdzPx5njub6f3h/resena_2_silver.png'
}, {
  name: 'Rosario F.',
  age: '61 años',
  context: 'abuela de 4 nietos',
  location: 'Madrid, España',
  quote: 'Mi hija me mandó esta página y la verdad lo primero que pensé fue "otra cosa de internet". Tengo 61 años y ya no creo en milagros. Pero el precio era tan bajo que dije, qué pierdo. Lo que más me gustó fue el recetario. Las cenas son ricas de verdad, no esa comida de dieta sin sabor que te hace sufrir. Al día 8 noté que el pantalón que no me cerraba ya cerraba. No perfectamente, pero cerraba. Eso para mí fue suficiente para seguir.',
  image: 'https://cdn.magicpatterns.com/uploads/9a3pYzFyLCno5HtcapGcgr/resena_3_silver.png'
}, {
  name: 'Linda K.',
  age: '54 años',
  context: 'profesora',
  location: 'Phoenix, Arizona',
  quote: 'I went through menopause at 49 and my body completely changed overnight. I tried keto, intermittent fasting, even a personal trainer for 3 months. Nothing touched the belly fat. A friend translated this program for me and I decided to try it. The cortisol explanation finally made sense of why everything I tried made me more stressed and more bloated. By day 10 I was sleeping through the night for the first time in two years. The scale moved, but honestly the sleep was the bigger win.',
  image: 'https://cdn.magicpatterns.com/uploads/3CDPsfrW2DK3mwNhBfoMhy/resena_4_silver.png'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-beige-light" data-id="element-229">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-231">
          <span className="inline-block px-4 py-1 rounded-full bg-gold/10 text-gold text-sm font-body tracking-widest uppercase mb-4" data-id="element-232">
            Mujeres como tú
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-233">
            Historias reales de transformación
          </h2>
          <p className="text-lg text-taupe-light font-body" data-id="element-234">
            Cada una empezó con dudas. Todas encontraron lo que llevaban años
            buscando.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-235">
          {testimonials.map((t, index) => <Card key={index} variant="elevated" className="p-8 md:p-10 flex flex-col" data-id="element-236">
              {/* Header: photo + name */}
              <div className="flex items-center gap-5 mb-6" data-id="element-237">
                <div className="relative flex-shrink-0" data-id="element-238">
                  <div className="absolute inset-0 bg-gold/20 rounded-full transform rotate-3 scale-105" data-id="element-239"></div>
                  <img src={t.image} alt={`Foto de ${t.name}`} className="relative w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-2 border-cream shadow-soft" data-id="element-240" />
                </div>
                <div className="min-w-0" data-id="element-241">
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-taupe leading-tight" data-id="element-242">
                    {t.name}
                  </h3>
                  <p className="font-body text-sm text-taupe-light mt-1" data-id="element-243">
                    {t.age} · {t.context}
                  </p>
                  <div className="flex items-center gap-1 mt-1 text-taupe-light" data-id="element-244">
                    <MapPinIcon className="w-3.5 h-3.5 text-gold" data-id="element-245" />
                    <span className="font-body text-xs" data-id="element-246">{t.location}</span>
                  </div>
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4" aria-label="Calificación de 5 estrellas" data-id="element-247">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="w-5 h-5 text-gold fill-gold" aria-hidden="true" data-id="element-248" />)}
              </div>

              {/* Quote */}
              <blockquote className="relative flex-1" data-id="element-249">
                <span aria-hidden="true" className="absolute -top-4 -left-2 font-heading text-6xl text-gold/20 leading-none select-none" data-id="element-250">
                  &ldquo;
                </span>
                <p className="font-body text-taupe-light leading-relaxed italic relative z-10" data-id="element-251">
                  {t.quote}
                </p>
              </blockquote>
            </Card>)}
        </div>
      </div>
    </section>;
}